import { render, staticRenderFns } from "./NotificationTaskUpdate.vue?vue&type=template&id=3315b9ed&scoped=true&lang=pug&"
import script from "./NotificationTaskUpdate.vue?vue&type=script&lang=js&"
export * from "./NotificationTaskUpdate.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTaskUpdate.vue?vue&type=style&index=0&id=3315b9ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3315b9ed",
  null
  
)

export default component.exports